// extracted by mini-css-extract-plugin
export default {"dynamicBanner":"QF-z"};